import { createMaybeSelector } from "../../utility/selectors";
/**
 * Get's customer data from domain
 *
 * @param domain Possible customer domain, which will contain the desired data
 * @returns If domain is valid return domain's data, otherwise return null
 */
export const getCustomer = (domain) => { var _a; return (_a = domain === null || domain === void 0 ? void 0 : domain.data) !== null && _a !== void 0 ? _a : null; };
/**
 * Calls createMaybeSelector() passing in getCustomer, and a Customer type to return the customer's first name
 */
export const getFirstName = createMaybeSelector(getCustomer, (customer) => customer.name.first);
/**
 * Calls createMaybeSelector() passing in getCustomer, and a Customer type to return the customer's delivery preference
 */
export const getStatementPreference = createMaybeSelector(getCustomer, (customer) => { var _a; return (_a = customer.meta) === null || _a === void 0 ? void 0 : _a.deliveryPreference; });
/**
 * Calls createMaybeSelector() passing in getCustomer, and a Customer type to return the customer's EtinStatusCode
 */
export const getEtinStatusCode = createMaybeSelector(getCustomer, (customer) => { var _a; return (_a = customer.meta) === null || _a === void 0 ? void 0 : _a.etinStatus; });
/**
 * Calls createMaybeSelector() passing in getCustomer, and a Customer type to return the customer's preferred name or first name if preferred name is null
 */
export const getGreetingName = createMaybeSelector(getCustomer, (customer) => { var _a; return ((_a = customer.preferredName) === null || _a === void 0 ? void 0 : _a.name) || customer.name.first; });
/**
 * Calls createMaybeSelector() passing in getCustomer, and a Customer type to return the customer's addresses
 */
export const getCustomerAddresses = createMaybeSelector(getCustomer, (customer) => customer.addresses);
//# sourceMappingURL=index.js.map